import React from "react";
import { ISpacerPartProps } from "../../models";
import css from "../../form.module.scss";

const Spacer = ({style}: ISpacerPartProps) => (<div  className={css.formPart} style={style}></div>);
export default Spacer;






